// ---------------------------
// detect window size
export function getWindowSize(breakpointValue) {
  const breakpoint = breakpointValue;
  return $(globalThis).width() >= breakpoint;
}

// ---------------------------
// search feature fixes
export function headerSearchBarFix(searchPlaceholder) {
  const showMobileSearch = false;
  const mobileTrigger = getWindowSize(800);

  const $searchBox = $('.header .searchBox');
  $searchBox.find('.searchBoxSubmit .inputFieldSubmit:first').attr('tabindex', '-1');
  $searchBox.find('input').val('').attr('placeholder', searchPlaceholder);

  if (showMobileSearch) {
    $searchBox.addClass('mobile-enabled');

    if (!mobileTrigger) {
      $searchBox.attr('tabindex', '0');
    }
  }
}

// ---------------------------
// dynamic margin
export function updateContentMargin() {
  function applyMargin() {
    const headerHeight = $('header').outerHeight();

    const mq = $('body').hasClass('saffireMobileSize');
    const additionalValue = mq ? 20 : 70;

    const content = $('.content');
    const socialDesktop = $('.header .social-container');
    const isHomepage = $('body').hasClass('homepage');

    content.css(
      'margin-top',
      isHomepage ? `${headerHeight}px` : `${headerHeight + additionalValue}px`,
    );

    if (!mq) {
      socialDesktop.css('top', `${headerHeight + 20}px`);
    }
  }
  applyMargin();

  $(globalThis).on('resize', applyMargin);

  let headerCollapsed = false;

  $(globalThis).on('scroll', function () {
    const shouldCollapse = $(this).scrollTop() > 20;

    if (shouldCollapse !== headerCollapsed) {
      headerCollapsed = shouldCollapse;
      setTimeout(applyMargin, 300);
    }
  });
}

// ---------------------------
// lineup alignment
export function modifyFeatureLineup() {
  const lineups = $('.featureLineupContainer');
  if (!lineups.length) return;

  lineups.each((_, el) => {
    const $lineup = $(el);
    const containerWidth = $lineup.width();
    const buttonContainer = $lineup.find('.featureLineup-buttons.subContainer');
    const icons = buttonContainer.find('.featureLineup-social');
    const cta = buttonContainer.find('.featureLineup-buynow');

    if (!icons.children().length) {
      icons.remove();
      buttonContainer.addClass('no-social');
      return;
    }

    const totalWidth = icons.outerWidth(true) + cta.outerWidth(true);

    if (totalWidth > containerWidth) {
      buttonContainer.addClass('column');
    }
  });
}

export function updateSocialWidgetPosition() {
  function moveSocialWidget() {
    const isMobile = $('body').hasClass('saffireMobileSize');
    let $socialWidget = $('.header .social-container .socialNetworks');

    if (isMobile) {
      $socialWidget.appendTo('.footer');
    } else {
      $socialWidget = $('.footer .socialNetworks');
      $socialWidget.appendTo('.header .social-container');
    }
  }

  moveSocialWidget();
  $(globalThis).on('resize', moveSocialWidget);
}

export function missingWidget(widgetName) {
  $('body').addClass(`${widgetName}-no-data`);
}
